const constants = {
  MESSAGE_STATUS_CONTAINER: "MESSAGE_STATUS_CONTAINER",
  HEADING_CONTAINER: "HEADING_CONTAINER",
  MESSAGE_STATUS_HEADER: "MESSAGE_STATUS_HEADER",
  MESSAGE_STATUS_COPY: "MESSAGE_STATUS_COPY",
  VIEW_ISSUES_BY: "VIEW_ISSUES_BY",
  BUTTON_GROUP_1: "BUTTON_GROUP_1",
  BUTTON_GROUP_2: "BUTTON_GROUP_2",
  PHONE_NUMBERS_BTN: "PHONE_NUMBERS_BTN",
  SUB_ACCOUNTS_BTN: "SUB_ACCOUNTS_BTN",
  MESSAGE_ERRORS_BTN: "MESSAGE_ERRORS_BTN",
  SCORE_BTN: "SCORE_BTN",
};

export default constants;
